import { HTTPMethod } from 'helpers/method';

import {
  CreateOrganizationPayload,
  CreateOrganizationResponse,
  OrganizationLimitation,
  OrganizationParams,
  OrganizationResponse,
} from './organization.type';
import { request } from '../configs/axiosConfig';
import { ENDPOINT } from '../configs/endpoint.constant';

export const OrganizationService = {
  getOrganizations: async (params: OrganizationParams = {}) => {
    return request<OrganizationResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_ORGANIZATIONS,
      params,
    });
  },

  createOrganization: async (data: CreateOrganizationPayload) => {
    return request<CreateOrganizationResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.CREATE_ORGANIZATION,
      data,
    });
  },

  deleteOrganization: async (id: string) => {
    return request({
      method: HTTPMethod.POST,
      url: `${ENDPOINT.DELETE_ORGANIZATION}/${id}`,
    });
  },

  updateOrganizationLimitations: async (
    orgId: string,
    limitations: Partial<OrganizationLimitation>
  ) => {
    return request({
      method: HTTPMethod.PUT,
      url: `${ENDPOINT.UPDATE_ORGANIZATION_LIMITATIONS}/${orgId}/limitations`,
      data: limitations,
    });
  },

  getOrganizationUsageData: async (id: string) => {
    return request({
      method: HTTPMethod.GET,
      url: `/organization/${id}/usage-histories`,
    });
  },
  getOrganizationUsageCurrent: async () => {
    return request({
      method: HTTPMethod.GET,
      url: `/organization/current`,
    });
  },
  getOrganizationUsageHistoryCurrent: async () => {
    return request({
      method: HTTPMethod.GET,
      url: `/organization/current/usage-histories`,
    });
  },

  getOrganizationUsers: async (id: string) => {
    return request({
      method: HTTPMethod.GET,
      url: `/organization/${id}/users`,
    });
  },

  updateOrganizationUser: async (
    orgId: string,
    userId: string,
    userData: {
      first_name: string;
      last_name: string;
      role: string;
      email: string;
    }
  ) => {
    console.log('OrganizationService.updateOrganizationUser called with:', {
      orgId,
      userId,
      userData,
    });
    try {
      const result = await request({
        method: HTTPMethod.PUT,
        url: `/organization/${orgId}/users/${userId}`,
        data: userData,
      });
      console.log('OrganizationService.updateOrganizationUser response:', result);

      // Check if the API response indicates success
      if (result && result.success === false) {
        const errorMessage = result.message || 'API call failed';
        console.error(
          'OrganizationService.updateOrganizationUser failed with success: false:',
          errorMessage
        );
        throw new Error(errorMessage);
      }

      console.log('OrganizationService.updateOrganizationUser successful:', result);
      return result;
    } catch (error) {
      console.error('OrganizationService.updateOrganizationUser failed:', error);
      throw error;
    }
  },

  deleteOrganizationUser: async (orgId: string, userId: string) => {
    console.log('OrganizationService.deleteOrganizationUser called with:', { orgId, userId });
    try {
      const result = await request({
        method: HTTPMethod.DELETE,
        url: `/organization/${orgId}/users/${userId}`,
      });
      console.log('OrganizationService.deleteOrganizationUser response:', result);
      return result;
    } catch (error) {
      console.error('OrganizationService.deleteOrganizationUser failed:', error);
      throw error;
    }
  },

  createOrganizationUser: async (
    orgId: string,
    userData: {
      email: string;
      role: string;
      first_name: string;
      last_name: string;
    }
  ) => {
    console.log('OrganizationService.createOrganizationUser called with:', { orgId, userData });
    try {
      const result = await request({
        method: HTTPMethod.POST,
        url: `/organization/${orgId}/users`,
        data: userData,
      });
      console.log('OrganizationService.createOrganizationUser response:', result);
      if (result && result.success === false) {
        const errorMessage = result.message || 'API call failed';
        console.error(
          'OrganizationService.createOrganizationUser failed with success: false:',
          errorMessage
        );
        throw new Error(errorMessage);
      }
      console.log('OrganizationService.createOrganizationUser successful:', result);
      return result;
    } catch (error) {
      console.error('OrganizationService.createOrganizationUser failed:', error);
      throw error;
    }
  },
};
